import { gql } from '@apollo/client';

export const getSellerStores = gql`
query getSellerStores(
  $pageSize: Int!
  $currentPage: Int!
  $filter: SellerStoreFilterInput
  $sort: SellerStoreSortInput
  $search: String
) {
  getSellerStores(
    pageSize: $pageSize
    currentPage: $currentPage
    filter: $filter
    sort: $sort
    search: $search
  ) {
    items {
      id
      code
      name
    }
  }
}
`;

export const getMarketplaceWarehouse = gql`
query getMarketplaceWarehouse($channel_code: String!) {
  getMarketplaceWarehouse(channel_code: $channel_code) {
    address
    id
    name
    type
  }
}
`;

export const csChannels = gql`
query csChannels(
  $filter: QueryCsChannelsFilterWhereConditions
  $sort: [QueryCsChannelsSortOrderByClause!]
  $first: Int!
  $page: Int
) {
  csChannels(filter: $filter, sort: $sort, first: $first, page: $page) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      channel_id
      channel_name
      channel_code
      channel_type
      channel_logo
      framework
      is_active
      country_id
      created_at
      updated_at
      config {
        features
      }
      credentials {
        id
        credentials_field
        description
        is_identifier
      }
      productIdentifier {
        id
        channel_attribute
        channel_variant_attribute
      }
    }
  }
}
`;

export const csGetChannelCredential = gql`
query csGetChannelCredential(
  $channel_code: String!
  $callback_url: String!
  $brand_id: String!
) {
  csGetChannelCredential(
    channel_code: $channel_code
    callback_url: $callback_url
    brand_id: $brand_id
  ) {
    brand_id
    type
    url_oauth2
    credentials {
      name
      type
      description
      is_identifier
      is_required
    }
    channel {
      channel_id
      channel_name
      channel_code
      channel_type
      channel_logo
      framework
      is_active
      country_id
      credentials {
        id
        credentials_field
        description
        is_identifier
      }
    }
  }
}
`;

export const csRegisterBrand = gql`
mutation csRegisterBrand(
  $channel_code: String!
  $request_id: Int
  $input: CsStoreBrandInput
) {
  csRegisterBrand(
    channel_code: $channel_code
    request_id: $request_id
    input: $input
  )
}
`;

export const csConnectToChannel = gql`
mutation csConnectToChannel(
  $input: CsConnectChannelInput!
  $framework: CsFramework!
) {
  csConnectToChannel(input: $input, framework: $framework)
}
`;

export const csCreateStoreRequest = gql`
mutation csCreateStoreRequest($input: CsStoreRequestInput!) {
  csCreateStoreRequest(input: $input)
}
`;

export const csStores = gql`
query csStores(
  $search: String
  $filter: QueryCsStoresFilterWhereConditions
  $hasChannel: QueryCsStoresHasChannelWhereHasConditions
  $sort: [QueryCsStoresSortOrderByClause!]
  $first: Int!
  $page: Int
) {
  csStores(
    search: $search
    filter: $filter
    hasChannel: $hasChannel
    sort: $sort
    first: $first
    page: $page
  ) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      store_id
      store_code
      store_name
      integrated_at
      status
      status_label
      channel {
        channel_logo
        channel_code
        channel_id
        config {
          is_multiwarehouse
        }
      }
      brands {
        store_brand_id
      }
      channel_binding_status
    }
  }
}
`;

export const csStoreRequests = gql`
query csStoreRequests(
  $filter: QueryCsStoreRequestsFilterWhereConditions
  $sort: [QueryCsStoreRequestsSortOrderByClause!]
  $first: Int!
  $page: Int
) {
  csStoreRequests(filter: $filter, sort: $sort, first: $first, page: $page) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      shop_link
      email
      status
      created_at
      updated_at
      channel {
        channel_logo
      }
    }
  }
}
`;

export const csSyncStoreStatusConnected = gql`
mutation csSyncStoreStatusConnected {
  csSyncStoreStatusConnected
}
`;

export const csDisconnectStore = gql`
mutation csDisconnectStore($store_id: Int!){
  csDisconnectStore(store_id: $store_id)
}
`;

export const csReconnectStore = gql`
mutation csReconnectStore(
  $store_id: Int!
  $credentials: [CsChannelCredentialInput]
) {
  csReconnectStore(store_id: $store_id, credentials: $credentials)
}
`;

export const csCancelStoreRequest = gql`
mutation csCancelStoreRequest($id: Int!) {
  csCancelStoreRequest(id: $id)
}
`;

export const getSellerLocByChannel = gql`
query getSellerLocByChannel($channel_code: String!) {
  getSellerLocByChannel(channel_code: $channel_code) {
    channel {
      channel_name
      image_url
    }
    locations {
      loc_code
      loc_id
      loc_name
      marketplace_warehouse_id
      marketplace_wh {
        id
        marketplace_warehouse_id
      }
    }
  }
}
`;

export const saveSellerLocByChannel = gql`
mutation saveSellerLocByChannel($input: SellerLocByChannelInput!) {
  saveSellerLocByChannel(input: $input)
}
`;

export const csConfig = gql`
query csConfig {
  csConfig {
    shopify_connector_channel_code
  }
}
`;

export const csUpdateStore = gql`
mutation csUpdateStore($store_id: Int!, $input: CsCreateStoreInput!) {
  csUpdateStore(store_id: $store_id, input: $input) {
    store_id
    store_name
  }
}
`;

export default {
    getSellerStores,
    getMarketplaceWarehouse,
    csChannels,
    csRegisterBrand,
    csGetChannelCredential,
    csConnectToChannel,
    csCreateStoreRequest,
    csStores,
    csStoreRequests,
    csSyncStoreStatusConnected,
    csDisconnectStore,
    csReconnectStore,
    csCancelStoreRequest,
    getSellerLocByChannel,
    saveSellerLocByChannel,
    csConfig,
    csUpdateStore,
};
